// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SammenlignRouteImport } from './routes/sammenlign'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivatlivRouteImport } from './routes/privatliv'
import { Route as OmOsRouteImport } from './routes/om-os'
import { Route as LoginRouteImport } from './routes/login'
import { Route as KontaktRouteImport } from './routes/kontakt'
import { Route as HandelsbetingelserRouteImport } from './routes/handelsbetingelser'
import { Route as CustomerMapLiveRouteImport } from './routes/customer-map-live'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as BilforhandlerChar123citySlugChar125RouteImport } from './routes/bilforhandler-{$citySlug}'
import { Route as BilerTilSalgRouteImport } from './routes/biler-til-salg'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as BilerTilSalgIndexRouteImport } from './routes/biler-til-salg.index'
import { Route as BilerTilSalgSlugRouteImport } from './routes/biler-til-salg.$slug'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminTrackingDebugRouteImport } from './routes/admin.tracking-debug'
import { Route as AdminSyncStatusRouteImport } from './routes/admin.sync-status'
import { Route as AdminSyncHealthRouteImport } from './routes/admin.sync-health'
import { Route as AdminSyncErrorsRouteImport } from './routes/admin.sync-errors'
import { Route as AdminSyncRouteImport } from './routes/admin.sync'
import { Route as AdminSeoRouteImport } from './routes/admin.seo'
import { Route as AdminProfilRouteImport } from './routes/admin.profil'
import { Route as AdminLeadEmailsRouteImport } from './routes/admin.lead-emails'
import { Route as AdminLandingByerRouteImport } from './routes/admin.landing-byer'
import { Route as AdminIndstillingerRouteImport } from './routes/admin.indstillinger'
import { Route as AdminFeedsRouteImport } from './routes/admin.feeds'
import { Route as AdminFeedPreviewRouteImport } from './routes/admin.feed-preview'
import { Route as AdminFeedHealthRouteImport } from './routes/admin.feed-health'
import { Route as AdminEmailsRouteImport } from './routes/admin.emails'
import { Route as AdminEmailVerifikationRouteImport } from './routes/admin.email-verifikation'
import { Route as AdminCustomerMapRouteImport } from './routes/admin.customer-map'
import { Route as AdminChatRouteImport } from './routes/admin.chat'
import { Route as AdminBrugereRouteImport } from './routes/admin.brugere'
import { Route as AdminBlogRouteImport } from './routes/admin.blog'
import { Route as AdminBilerRouteImport } from './routes/admin.biler'
import { Route as AdminBeskederRouteImport } from './routes/admin.beskeder'
import { Route as AdminAuditRouteImport } from './routes/admin.audit'
import { Route as AdminAnmeldelserRouteImport } from './routes/admin.anmeldelser'
import { Route as AdminBeskederMessageIdRouteImport } from './routes/admin.beskeder.$messageId'

const SammenlignRoute = SammenlignRouteImport.update({
            id: '/sammenlign',path: '/sammenlign',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const PrivatlivRoute = PrivatlivRouteImport.update({
            id: '/privatliv',path: '/privatliv',getParentRoute: () => rootRouteImport
          })
const OmOsRoute = OmOsRouteImport.update({
            id: '/om-os',path: '/om-os',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const KontaktRoute = KontaktRouteImport.update({
            id: '/kontakt',path: '/kontakt',getParentRoute: () => rootRouteImport
          })
const HandelsbetingelserRoute = HandelsbetingelserRouteImport.update({
            id: '/handelsbetingelser',path: '/handelsbetingelser',getParentRoute: () => rootRouteImport
          })
const CustomerMapLiveRoute = CustomerMapLiveRouteImport.update({
            id: '/customer-map-live',path: '/customer-map-live',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const BilforhandlerChar123citySlugChar125Route = BilforhandlerChar123citySlugChar125RouteImport.update({
            id: '/bilforhandler-{$citySlug}',path: '/bilforhandler-{$citySlug}',getParentRoute: () => rootRouteImport
          })
const BilerTilSalgRoute = BilerTilSalgRouteImport.update({
            id: '/biler-til-salg',path: '/biler-til-salg',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })
const BilerTilSalgIndexRoute = BilerTilSalgIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BilerTilSalgRoute
          })
const BilerTilSalgSlugRoute = BilerTilSalgSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BilerTilSalgRoute
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminTrackingDebugRoute = AdminTrackingDebugRouteImport.update({
            id: '/tracking-debug',path: '/tracking-debug',getParentRoute: () => AdminRoute
          })
const AdminSyncStatusRoute = AdminSyncStatusRouteImport.update({
            id: '/sync-status',path: '/sync-status',getParentRoute: () => AdminRoute
          })
const AdminSyncHealthRoute = AdminSyncHealthRouteImport.update({
            id: '/sync-health',path: '/sync-health',getParentRoute: () => AdminRoute
          })
const AdminSyncErrorsRoute = AdminSyncErrorsRouteImport.update({
            id: '/sync-errors',path: '/sync-errors',getParentRoute: () => AdminRoute
          })
const AdminSyncRoute = AdminSyncRouteImport.update({
            id: '/sync',path: '/sync',getParentRoute: () => AdminRoute
          })
const AdminSeoRoute = AdminSeoRouteImport.update({
            id: '/seo',path: '/seo',getParentRoute: () => AdminRoute
          })
const AdminProfilRoute = AdminProfilRouteImport.update({
            id: '/profil',path: '/profil',getParentRoute: () => AdminRoute
          })
const AdminLeadEmailsRoute = AdminLeadEmailsRouteImport.update({
            id: '/lead-emails',path: '/lead-emails',getParentRoute: () => AdminRoute
          })
const AdminLandingByerRoute = AdminLandingByerRouteImport.update({
            id: '/landing-byer',path: '/landing-byer',getParentRoute: () => AdminRoute
          })
const AdminIndstillingerRoute = AdminIndstillingerRouteImport.update({
            id: '/indstillinger',path: '/indstillinger',getParentRoute: () => AdminRoute
          })
const AdminFeedsRoute = AdminFeedsRouteImport.update({
            id: '/feeds',path: '/feeds',getParentRoute: () => AdminRoute
          })
const AdminFeedPreviewRoute = AdminFeedPreviewRouteImport.update({
            id: '/feed-preview',path: '/feed-preview',getParentRoute: () => AdminRoute
          })
const AdminFeedHealthRoute = AdminFeedHealthRouteImport.update({
            id: '/feed-health',path: '/feed-health',getParentRoute: () => AdminRoute
          })
const AdminEmailsRoute = AdminEmailsRouteImport.update({
            id: '/emails',path: '/emails',getParentRoute: () => AdminRoute
          })
const AdminEmailVerifikationRoute = AdminEmailVerifikationRouteImport.update({
            id: '/email-verifikation',path: '/email-verifikation',getParentRoute: () => AdminRoute
          })
const AdminCustomerMapRoute = AdminCustomerMapRouteImport.update({
            id: '/customer-map',path: '/customer-map',getParentRoute: () => AdminRoute
          })
const AdminChatRoute = AdminChatRouteImport.update({
            id: '/chat',path: '/chat',getParentRoute: () => AdminRoute
          })
const AdminBrugereRoute = AdminBrugereRouteImport.update({
            id: '/brugere',path: '/brugere',getParentRoute: () => AdminRoute
          })
const AdminBlogRoute = AdminBlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => AdminRoute
          })
const AdminBilerRoute = AdminBilerRouteImport.update({
            id: '/biler',path: '/biler',getParentRoute: () => AdminRoute
          })
const AdminBeskederRoute = AdminBeskederRouteImport.update({
            id: '/beskeder',path: '/beskeder',getParentRoute: () => AdminRoute
          })
const AdminAuditRoute = AdminAuditRouteImport.update({
            id: '/audit',path: '/audit',getParentRoute: () => AdminRoute
          })
const AdminAnmeldelserRoute = AdminAnmeldelserRouteImport.update({
            id: '/anmeldelser',path: '/anmeldelser',getParentRoute: () => AdminRoute
          })
const AdminBeskederMessageIdRoute = AdminBeskederMessageIdRouteImport.update({
            id: '/$messageId',path: '/$messageId',getParentRoute: () => AdminBeskederRoute
          })





const AdminBeskederRouteChildren = {
  AdminBeskederMessageIdRoute: AdminBeskederMessageIdRoute
}

const AdminBeskederRouteWithChildren = AdminBeskederRoute._addFileChildren(AdminBeskederRouteChildren)



const AdminRouteChildren = {
  AdminAnmeldelserRoute: AdminAnmeldelserRoute,AdminAuditRoute: AdminAuditRoute,AdminBeskederRoute: AdminBeskederRouteWithChildren,AdminBilerRoute: AdminBilerRoute,AdminBlogRoute: AdminBlogRoute,AdminBrugereRoute: AdminBrugereRoute,AdminChatRoute: AdminChatRoute,AdminCustomerMapRoute: AdminCustomerMapRoute,AdminEmailVerifikationRoute: AdminEmailVerifikationRoute,AdminEmailsRoute: AdminEmailsRoute,AdminFeedHealthRoute: AdminFeedHealthRoute,AdminFeedPreviewRoute: AdminFeedPreviewRoute,AdminFeedsRoute: AdminFeedsRoute,AdminIndstillingerRoute: AdminIndstillingerRoute,AdminLandingByerRoute: AdminLandingByerRoute,AdminLeadEmailsRoute: AdminLeadEmailsRoute,AdminProfilRoute: AdminProfilRoute,AdminSeoRoute: AdminSeoRoute,AdminSyncRoute: AdminSyncRoute,AdminSyncErrorsRoute: AdminSyncErrorsRoute,AdminSyncHealthRoute: AdminSyncHealthRoute,AdminSyncStatusRoute: AdminSyncStatusRoute,AdminTrackingDebugRoute: AdminTrackingDebugRoute,AdminIndexRoute: AdminIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const BilerTilSalgRouteChildren = {
  BilerTilSalgSlugRoute: BilerTilSalgSlugRoute,BilerTilSalgIndexRoute: BilerTilSalgIndexRoute
}

const BilerTilSalgRouteWithChildren = BilerTilSalgRoute._addFileChildren(BilerTilSalgRouteChildren)




const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRouteWithChildren,BilerTilSalgRoute: BilerTilSalgRouteWithChildren,BilforhandlerChar123citySlugChar125Route: BilforhandlerChar123citySlugChar125Route,BlogRoute: BlogRouteWithChildren,CustomerMapLiveRoute: CustomerMapLiveRoute,HandelsbetingelserRoute: HandelsbetingelserRoute,KontaktRoute: KontaktRoute,LoginRoute: LoginRoute,OmOsRoute: OmOsRoute,PrivatlivRoute: PrivatlivRoute,ResetPasswordRoute: ResetPasswordRoute,SammenlignRoute: SammenlignRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)